import React, { Component, Fragment } from 'react'
import { Button3D } from './../button3D'

import PLAY_PNG from 'public/assets/png/play_i_500dpi_4276.png'
import PAUSE_PNG from 'public/assets/png/pause_4000.png'
import { any } from 'prop-types'
import debounce from 'lodash-es/debounce'

// Wrapper component that defines callbacks to manipulate attributes on callbacks to drive animations
// on wrapped 3d mesh component

class PositionalMediaButton3D extends Component {
    constructor(props) {
        super(props)
        this.state = {
            playing: false,
        }
        this.actions = {
            root: {},
            sprite: {},
            border: {},
            button: {},
        }
        this.mixers = {}
        this.clock = new THREE.Clock()
        this.rootObj
        this.buttonObj
        this.borderObj
        this.spriteObj

        this.createAnimations = debounce(this.createAnimations.bind(this), 60)
    }

    createAnimations = obj => {
        this.rootObj = obj.parent
        this.buttonObj = obj
        this.borderObj = obj.getObjectByName('border', true)
        this.spriteObj = obj.parent.getObjectByName('spriteContainer', true)
        // https://threejs.org/docs/#api/en/animation/AnimationMixer
        // "The AnimationMixer is a player for animations on a particular object in the scene.
        //  When multiple objects in the scene are animated independently, one AnimationMixer may be used for each object."
        this.mixers.rootMixer = new THREE.AnimationMixer(this.rootObj)
        this.mixers.buttonMixer = new THREE.AnimationMixer(this.buttonObj)
        this.mixers.borderMixer = new THREE.AnimationMixer(this.borderObj)
        this.mixers.spriteMixer = new THREE.AnimationMixer(this.spriteObj)

        // // Root Anim
        // var disappearKF = new THREE.VectorKeyframeTrack('.material.opacity', [0, 0.75], [1, 0])
        // var disappearClip = new THREE.AnimationClip('buttonHoverDisappearOpacity', 0.75, [disappearKF])
        // this.actions.root.disappearClip = this.mixers.rootMixer.clipAction(disappearClip)
        // this.actions.root.disappearClip.loop = THREE.LoopOnce
        // this.actions.root.disappearClip.clampWhenFinished = true

        // GROUP ANIMS

        // Animation for making PM button invisible
        var hoverDisappearOpacityKF = new THREE.VectorKeyframeTrack('.material.opacity', [0, 0.75], [1, 0])
        var hoverDisappearOpacityClip = new THREE.AnimationClip('buttonHoverDisappearOpacity', 0.75, [
            hoverDisappearOpacityKF,
        ])

        this.actions.button.hoverDisappearOpacityClip = this.mixers.buttonMixer.clipAction(hoverDisappearOpacityClip)
        this.actions.button.hoverDisappearOpacityClip.loop = THREE.LoopOnce
        this.actions.button.hoverDisappearOpacityClip.clampWhenFinished = true

        this.actions.border.hoverDisappearOpacityClip = this.mixers.borderMixer.clipAction(hoverDisappearOpacityClip)
        this.actions.border.hoverDisappearOpacityClip.loop = THREE.LoopOnce
        this.actions.border.hoverDisappearOpacityClip.clampWhenFinished = true

        // this.actions.sprite.hoverDisappearOpacityClip = this.mixers.spriteMixer.clipAction(
        //     hoverDisappearOpacityClip
        // )
        // this.actions.sprite.hoverDisappearOpacityClip.loop = THREE.LoopOnce
        // this.actions.sprite.hoverDisappearOpacityClip.clampWhenFinished = true

        // Animation for making PM button visible
        var hoverAppearOpacityKF = new THREE.VectorKeyframeTrack('.material.opacity', [0, 0.75], [0, 1])
        var hoverAppearOpacityClip = new THREE.AnimationClip('buttonHoverAppearOpacity', 0.75, [hoverAppearOpacityKF])

        this.actions.button.hoverAppearOpacityClip = this.mixers.buttonMixer.clipAction(hoverAppearOpacityClip)
        this.actions.button.hoverAppearOpacityClip.loop = THREE.LoopOnce
        this.actions.button.hoverAppearOpacityClip.clampWhenFinished = true

        this.actions.border.hoverAppearOpacityClip = this.mixers.borderMixer.clipAction(hoverAppearOpacityClip)
        this.actions.border.hoverAppearOpacityClip.loop = THREE.LoopOnce
        this.actions.border.hoverAppearOpacityClip.clampWhenFinished = true

        // this.actions.sprite.hoverAppearOpacityClip = this.mixers.spriteMixer.clipAction(hoverAppearOpacityClip)
        // this.actions.sprite.hoverAppearOpacityClip.loop = THREE.LoopOnce
        // this.actions.sprite.hoverAppearOpacityClip.clampWhenFinished = true

        // BUTTON ANIMS

        // Animation for increasing opacity on hover
        var hoverEnterOpacityKF = new THREE.VectorKeyframeTrack(
            '.material.opacity',
            [0, 0.75],
            [this.buttonObj.material.opacity, 1]
        )
        var hoverEnterOpacityClip = new THREE.AnimationClip('buttonHoverEnterOpacity', 0.75, [hoverEnterOpacityKF])
        this.actions.button.hoverEnterOpacityClip = this.mixers.buttonMixer.clipAction(hoverEnterOpacityClip)
        this.actions.button.hoverEnterOpacityClip.loop = THREE.LoopOnce
        this.actions.button.hoverEnterOpacityClip.clampWhenFinished = true

        // Animation for decreasing opacity on hover
        var hoverExitOpacityKF = new THREE.VectorKeyframeTrack(
            '.material.opacity',
            [0, 0.75],
            [1, this.buttonObj.material.opacity]
        )
        var hoverExitOpacityClip = new THREE.AnimationClip('buttonHoverExitOpacity', 0.75, [hoverExitOpacityKF])
        this.actions.button.hoverExitOpacityClip = this.mixers.buttonMixer.clipAction(hoverExitOpacityClip)
        this.actions.button.hoverExitOpacityClip.loop = THREE.LoopOnce
        this.actions.button.hoverExitOpacityClip.clampWhenFinished = true

        // SPRITE ANIMS

        // Animation for slightly increasing scale on hover
        var hoverEnterScaleKF = new THREE.VectorKeyframeTrack('.scale', [0, 0.25], [1, 1, 1, 1.1, 1.1, 1.1])
        var hoverEnterScaleClip = new THREE.AnimationClip('spriteHoverEnterScale', 0.75, [hoverEnterScaleKF])
        this.actions.sprite.hoverEnterScaleClip = this.mixers.spriteMixer.clipAction(hoverEnterScaleClip)
        this.actions.sprite.hoverEnterScaleClip.loop = THREE.LoopOnce
        this.actions.sprite.hoverEnterScaleClip.clampWhenFinished = true

        // Animation for slightly decreasing scale on exit
        var hoverExitScaleKF = new THREE.VectorKeyframeTrack('.scale', [0, 0.25], [1.1, 1.1, 1.1, 1, 1, 1])
        var hoverExitScaleClip = new THREE.AnimationClip('spriteHoverExitScale', 0.75, [hoverExitScaleKF])
        this.actions.sprite.hoverExitScaleClip = this.mixers.spriteMixer.clipAction(hoverExitScaleClip)
        this.actions.sprite.hoverExitScaleClip.loop = THREE.LoopOnce
        this.actions.sprite.hoverExitScaleClip.clampWhenFinished = true

        this.animateMixers()
    }

    handleMouseOver = () => {
        const { playing } = this.state
        const { onHover, setCursor, isMobile } = this.props
        // wire this up to setCursor in container component so that cursor style chamnges
        setCursor && setCursor('pointer')

        // Clears timeout to make element invisible
        this.invisibleTimout && clearTimeout(this.invisibleTimout)

        this.actions.button.hoverExitOpacityClip.stop()

        this.actions.sprite.hoverEnterScaleClip.play()
        this.actions.sprite.hoverExitScaleClip.stop()

        if (playing) {
            // NOTE: GOING TO NEED TO USE SCALE TO APPROXIMATE DISAPPEARANCE
            // NEED TO INVESTIGATE INTERACTIONS B/T PM AND OTHER ELEMENTS
            // USING OPACITY TO HIDE ERESULTS IN PM BEING 'REMOVED'
            this.actions.button.hoverAppearOpacityClip.play()
            this.actions.border.hoverAppearOpacityClip.play()
            // this.actions.sprite.hoverAppearOpacityClip.play()
            // toggle visibility of root object if mobile
            if (!isMobile) {
                this.rootObj.visible = true
            }
        } else {
            this.actions.button.hoverEnterOpacityClip.play()
        }

        onHover && onHover()
    }

    handleMouseOut = () => {
        const { playing } = this.state
        const { onHoverExit, setCursor, isMobile } = this.props
        if (playing) {
            this.actions.button.hoverDisappearOpacityClip.play()
            this.actions.border.hoverDisappearOpacityClip.play()
            // this.actions.sprite.hoverDisappearOpacityClip.play()
            // toggle visibility of root object if mobile
            if (!isMobile) {
                this.invisibleTimout = setTimeout(() => {
                    this.rootObj.visible = false
                }, 2000)
            }
        } else {
            this.actions.button.hoverExitOpacityClip.play()
        }
        this.actions.button.hoverEnterOpacityClip.stop()

        this.actions.sprite.hoverExitScaleClip.play()
        this.actions.sprite.hoverEnterScaleClip.stop()
        // wire this up to setCursor in container component so that cursor style chamnges
        setCursor && setCursor('grab')
        onHoverExit && onHoverExit()
    }

    handleClick = () => {
        const { playing } = this.state
        const { onClick, isMobile } = this.props
        // Hide positional media button while playing if on mobile
        if (isMobile) {
            this.rootObj.visible = playing
        }
        this.setState(prevState => ({ playing: !prevState.playing }))
        onClick && onClick()
    }

    animateMixers = () => {
        var delta = this.clock.getDelta()
        this.mixers &&
            Object.keys(this.mixers).forEach(mixerKey => {
                this.mixers[mixerKey].update(delta)
            })
        this.raf = requestAnimationFrame(this.animateMixers)
    }

    componentWillUnmount() {
        this.raf && cancelAnimationFrame(this.raf)
        clearTimeout(this.invisibleTimout)
    }

    render() {
        const { playing } = this.state
        const { position, currentState, isVisible, meshPosition, progress, ...props } = this.props

        return (
            <Button3D
                createAnimations={this.createAnimations}
                meshPosition={meshPosition}
                handleClick={this.handleClick}
                hasScrubBar={true}
                width={1}
                height={0.6}
                percentageComplete={progress}
                showSprite={true}
                spriteResource={!playing ? PLAY_PNG : PAUSE_PNG}
                handleMouseOver={this.handleMouseOver}
                handleMouseOut={this.handleMouseOut}
                {...props}
            />
        )
    }
}

export default PositionalMediaButton3D
